module.exports = __webpack_public_path__ + "99cbdeb53950d8e106bce72872cdbf33.png";